import type { PropsWithChildren } from "react"

export function DataTable({ children }: PropsWithChildren) {
  return (
    <div className="w-full overflow-x-auto">
      <table className="min-w-[720px] w-full text-left text-xs text-slate-700 sm:text-sm">
        {children}
      </table>
    </div>
  )
}

export function TableHead({ children }: PropsWithChildren) {
  return (
    <thead>
      <tr className="bg-slate-50 text-slate-500 font-bold uppercase border-b border-slate-100">
        {children}
      </tr>
    </thead>
  )
}

export function Th({
  children,
  className = "",
}: PropsWithChildren<{ className?: string }>) {
  return <th className={`px-3 py-3 sm:px-4 ${className}`}>{children}</th>
}

export function Td({
  children,
  className = "",
}: PropsWithChildren<{ className?: string }>) {
  return <td className={`px-3 py-3 sm:px-4 ${className}`}>{children}</td>
}

export function TableBody({ children }: PropsWithChildren) {
  return <tbody className="divide-y divide-slate-100">{children}</tbody>
}

export function TableRow({
  children,
  onClick,
  className = "",
}: PropsWithChildren<{ onClick?: () => void; className?: string }>) {
  return (
    <tr
      className={`hover:bg-slate-50 transition-colors focus-within:bg-slate-50 ${onClick ? "cursor-pointer" : ""} ${className}`}
      onClick={onClick}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault()
                onClick()
              }
            }
          : undefined
      }
      tabIndex={onClick ? 0 : undefined}
    >
      {children}
    </tr>
  )
}
